import { Stack, Typography, useTheme } from "@mui/material";
import { TasksResponse } from "@/modules/tasks/dtos";
import { useCallback } from "react";
import TaskItem from "./task-item";
import TaskSkeleton from "./task-skeleton";

interface Props {
  isLoading: boolean;
  tasks: TasksResponse[];
  completingTaskId: string | null;

  onTaskClick(task: TasksResponse): void;
  onMarkComplete(taskId: string): void;
}

const TasksView = ({
  isLoading,
  tasks,
  completingTaskId,
  onTaskClick,
  onMarkComplete,
}: Props) => {
  const theme = useTheme();

  const renderTasksList = useCallback(() => {
    if (isLoading) {
      return (
        <Stack direction="column" spacing={theme.nawy.spacing.md}>
          <TaskSkeleton />
        </Stack>
      );
    }

    if (!tasks || tasks.length === 0) {
      return (
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            color: theme.nawy.colors.semantic.text.primary,
          }}
        >
          No tasks yet
        </Typography>
      );
    }

    return (
      <Stack direction="column" spacing={theme.nawy.spacing.md}>
        {tasks.map((task) => {
          return (
            <TaskItem
              key={task.uid}
              task={task}
              isCompleting={completingTaskId === task.uid}
              handleMarkComplete={onMarkComplete}
              onClick={() => onTaskClick(task)}
            />
          );
        })}
      </Stack>
    );
  }, [isLoading, tasks, completingTaskId, theme, onTaskClick, onMarkComplete]);

  return <Stack spacing={theme.nawy.spacing.md}>{renderTasksList()}</Stack>;
};

export default TasksView;
